const assets = {
  icons: {
    success: require('./icons/success.png'),
    error: require('./icons/error.png'),
    info: require('./icons/info.png'),
    close: require('./icons/close.png')
  }
};

const { icons } = assets;

export { icons };
export default assets;
